import type { SortSpec } from '@moment/horizon-data-access/platform'
import type { AccountSortInput } from '../account-query-sorm-types'

import {
  DEFAULT_ACCOUNT_SORT,
  SORM_ACCOUNT_FIELD_BY_PUBLIC_FIELD,
} from '../constants'

const RANKED_RATING_SORT_FIELDS: Readonly<Record<string, string>> = {
  average_sp_rating: 'average_sp_rating_rank',
  average_moodys_rating: 'average_moodys_rating_rank',
}

function sormSortField(field: string): string {
  const sormField = SORM_ACCOUNT_FIELD_BY_PUBLIC_FIELD[field] ?? field
  return RANKED_RATING_SORT_FIELDS[sormField] ?? sormField
}

/**
 * Translates legacy account GraphQL sorts into SORM sort specs, defaulting to
 * account name ascending like public-api's account GraphQL resolver.
 */
export function translateAccountSort(
  sort: AccountSortInput | AccountSortInput[] | null | undefined,
): SortSpec[] {
  const sorts = Array.isArray(sort) ? sort : [sort].filter((s) => s != null)
  if (sorts.length === 0) {
    return [DEFAULT_ACCOUNT_SORT]
  }
  return sorts.map(({ field, direction }) => ({
    entity: 'Account',
    field: sormSortField(field),
    // SORM compares sort direction case-sensitively against lowercase values.
    direction: direction === 'DESC' ? 'desc' : 'asc',
  }))
}
